import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ModalService } from 'src/app/shared/services/modal.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

import { introSlider, offering } from '../data';
import { environment } from '../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SearchService } from '../../../shared/services/search.service';
import { DataService } from 'src/app/shared/services/data.service';
import { StoreService } from 'src/app/core/store/store.service';

@Component({
    selector: 'indiapicture-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss']
})

export class IndexComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();

    products = [];
    posts = [];
    loaded = false;
    introSlider = introSlider;
    // introSlider1 = introSlider1;
    setting: any;
    offering = offering;
    // brandSlider = brandSlider;
    showbanner = environment.showBanner;
    headerType: string = environment.headerType;
    slides = [];
    banners = [];
    noOfImages = 0;
    showText = 1;
    deals = [];
    categories = [];
    isMobile = false;
    offers = [];
    currentUser = { isExclusive: false };

    constructor(public apiService: ApiService, public utilsService: UtilsService, private modalService: ModalService,
        private searchService: SearchService, private dataService: DataService, private StorageService: StoreService) {
        // this.modalService.openNewsletter();

        this.apiService.fetchSettings().subscribe(result => {
            this.setting = result.data;
            // console.log(this.setting);
            this.updateSetting();
            this.loaded = true;
        });
        this.searchService = SearchService.getInstance();
        this.searchService.setSearch('');
        this.searchService.setCategory('creative');
    }

    updateSetting() {
        this.slides = this.setting.home.slides.filter(item => item.published == 1);
        this.banners = this.setting.home.banners;
        this.offers = this.setting.offer;
        this.deals = this.setting.home.deals;
        this.categories = this.setting.home.categories;
        this.noOfImages = Number(this.setting.setting[0].title);
        this.showText = this.setting.setting[0].published;
    }


    showModal(event: Event) {
        event.preventDefault();
        // console.log(event.currentTarget['href']);
        // this.modalService.showVideoModal(event.currentTarget['href']);
    }

    ngOnInit() {
        if (window.innerWidth <= 500) {
            this.isMobile = true;
        }
        this.getCurrentUser();
    }

    getCurrentUser() {
        this.dataService.currentData$
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
         //  console.log('index component', data);
            if (data) {
            this.currentUser = data;
            }else{
                const user = this.StorageService.getItem('currentUser');
             //  console.log('StorageService ==>', user);
                if (user) {
                 //  console.log('currentUser ==> ', user);
                    this.currentUser = user;
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
